"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotSupportedV2Error = exports.NotSupportedV1Error = exports.NotSupportedError = void 0;
/**
 * @hidden
 */
var NotSupportedError = /** @class */ (function (_super) {
    __extends(NotSupportedError, _super);
    function NotSupportedError(property, method) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, "Not supported. You need to define \"".concat(property, "\" configuration property to use ").concat(method, "()")) || this;
        _this.property = property;
        _this.method = method;
        _this.name = 'NOT_SUPPORTED';
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return NotSupportedError;
}(Error));
exports.NotSupportedError = NotSupportedError;
var NotSupportedV1Error = /** @class */ (function (_super) {
    __extends(NotSupportedV1Error, _super);
    function NotSupportedV1Error(method) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, 'account', method) || this;
        _this.method = method;
        _this.name = 'NOT_SUPPORTED_V1';
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return NotSupportedV1Error;
}(NotSupportedError));
exports.NotSupportedV1Error = NotSupportedV1Error;
var NotSupportedV2Error = /** @class */ (function (_super) {
    __extends(NotSupportedV2Error, _super);
    function NotSupportedV2Error(method) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, 'hubName', method) || this;
        _this.method = method;
        _this.name = 'NOT_SUPPORTED_V2';
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return NotSupportedV2Error;
}(NotSupportedError));
exports.NotSupportedV2Error = NotSupportedV2Error;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTm90U3VwcG9ydGVkRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL2NvbnRlbnQvbW9kZWwvTm90U3VwcG9ydGVkRXJyb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0dBRUc7QUFDSDtJQUF1QyxxQ0FBSztJQU0xQywyQkFBbUIsUUFBZ0IsRUFBUyxNQUFjOztRQUExRCxZQUNFLGtCQUNFLDhDQUFzQyxRQUFRLDhDQUFtQyxNQUFNLE9BQUksQ0FDNUYsU0FFRjtRQUxrQixjQUFRLEdBQVIsUUFBUSxDQUFRO1FBQVMsWUFBTSxHQUFOLE1BQU0sQ0FBUTtRQUwxQyxVQUFJLEdBR0UsZUFBZSxDQUFDO1FBTXBDLE1BQU0sQ0FBQyxjQUFjLENBQUMsS0FBSSxFQUFFLFdBQVcsU0FBUyxDQUFDLENBQUM7O0lBQ3BELENBQUM7SUFDSCx3QkFBQztBQUFELENBQUMsQUFaRCxDQUF1QyxLQUFLLEdBWTNDO0FBWlksOENBQWlCO0FBYzlCO0lBQXlDLHVDQUFpQjtJQUd4RCw2QkFBbUIsTUFBYzs7UUFBakMsWUFDRSxrQkFBTSxTQUFTLEVBQUUsTUFBTSxDQUFDLFNBRXpCO1FBSGtCLFlBQU0sR0FBTixNQUFNLENBQVE7UUFGakIsVUFBSSxHQUFHLGtCQUFrQixDQUFDO1FBSXhDLE1BQU0sQ0FBQyxjQUFjLENBQUMsS0FBSSxFQUFFLFdBQVcsU0FBUyxDQUFDLENBQUM7O0lBQ3BELENBQUM7SUFDSCwwQkFBQztBQUFELENBQUMsQUFQRCxDQUF5QyxpQkFBaUIsR0FPekQ7QUFQWSxrREFBbUI7QUFRaEM7SUFBeUMsdUNBQWlCO0lBR3hELDZCQUFtQixNQUFjOztRQUFqQyxZQUNFLGtCQUFNLFNBQVMsRUFBRSxNQUFNLENBQUMsU0FFekI7UUFIa0IsWUFBTSxHQUFOLE1BQU0sQ0FBUTtRQUZqQixVQUFJLEdBQUcsa0JBQWtCLENBQUM7UUFJeEMsTUFBTSxDQUFDLGNBQWMsQ0FBQyxLQUFJLEVBQUUsV0FBVyxTQUFTLENBQUMsQ0FBQzs7SUFDcEQsQ0FBQztJQUNILDBCQUFDO0FBQUQsQ0FBQyxBQVBELENBQXlDLGlCQUFpQixHQU96RDtBQVBZLGtEQUFtQiJ9